import ApiClient from './ApiClient';

interface Action {
	type: string;
}
export interface State {
	client: ApiClient | null;
}

function createState(): State {
	return {
		client: null,
	};
}

export default function reducer(state: State = createState(), action: Action): State {
	switch (action.type) {
		default:
			return state;
	}
}
